import React, { useCallback } from 'react';
import { useModalStore } from '@/store/useModalStore';
import { Dropdown } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import logoWhite from '@/assets/svg/aixuehome-logo.svg';

export interface AixueFooterProps {}

export default function AixueFooter(props: AixueFooterProps) {
  const navigate = useNavigate();
  const { openModalMask } = useModalStore();
  // 仅负责回到顶部，与路由跳转（Link）解耦
  const scrollToTopDeferred = useCallback(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const selectors = ['[data-scroll-root="aixue-phonics"]', '.aixue-about-scroll'];
        for (const sel of selectors) {
          const node = document.querySelector(sel) as HTMLElement | null;
          if (node) node.scrollTo({ top: 0, behavior: 'auto' });
        }
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    });
  }, []);

  const footerProductsItems = [
    {
      key: 'products-ai',
      label: <span className="aixue-menu-link">爱学AI学习智能体</span>,
      onClick: () => navigate('/aixue-ai'),
    },
    {
      key: 'products-phonics',
      label: <span className="aixue-menu-link">爱学AI低龄段产品矩阵</span>,
      onClick: () => navigate('/aixue-phonics'),
    },
  ];

  return (
    <footer className={styles['footer-cover']}>
      <div className={styles['footer-wrap']}>
        <div className={styles['footer-top']}>
          <div className={styles['footer-left']}>
            <img src={logoWhite} alt="logo" className={styles.logo} />
            <div className={styles['nav']}>
              <Link to="/" className={styles['nav-item']} onClick={scrollToTopDeferred}>
                首页
              </Link>

              <Dropdown
                trigger={['hover']}
                menu={{ items: footerProductsItems }}
                overlayClassName="aixue-bottom-menu-overlay"
                placement="bottom"
                mouseLeaveDelay={0.4}
              >
                <span className={`aixue-menu-link ${styles['nav-item']}`}>产品中心</span>
              </Dropdown>
              <Link to="/aixue-about" className={styles['nav-item']} onClick={scrollToTopDeferred}>
                关于我们
              </Link>
              <Link to="/aixue-join" className={styles['nav-item']} onClick={scrollToTopDeferred}>
                加入我们
              </Link>
              <Link
                to="/aixue-download"
                className={styles['nav-item']}
                onClick={scrollToTopDeferred}
              >
                下载中心
              </Link>
            </div>
          </div>

          <div className={styles['footer-right']}>
            <div className={styles['footer-text']}>关注我们</div>
            <div className={styles['socials']}>
              <div className={`${styles['social-btn']} ${styles['social-btn1']}`}>
                <div className={styles['social-btn-qr']}>
                  <div className={styles['social-icon']}></div>
                </div>
              </div>
              <div className={`${styles['social-btn']} ${styles['social-btn2']}`}>
                <div className={styles['social-btn-qr']}>
                  <div className={styles['social-icon']}></div>
                </div>
              </div>
              <div
                className={`${styles['social-btn']} ${styles['social-btn3']}`}
                onClick={() =>
                  window.open(
                    'https://www.xiaohongshu.com/user/profile/68789009000000001e03ecd4',
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              ></div>
            </div>
          </div>
        </div>

        <div className={styles['footer-divider']}></div>

        <div className={styles['footer-bottom']}>
          <div className={styles['meta']}>
            <div className={styles['meta-line']}>
              <span>北京与爱为舞科技有限公司 版权所有</span>
            </div>
            <div className="flex items-center gap-4px">
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802046217"
                target="_blank"
                className="text-13px text-white hover:text-white"
              >
                京公网安备11010802046217号
              </a>
              <a
                href="https://beian.miit.gov.cn"
                target="_blank"
                className="text-13px text-white hover:text-white"
              >
                京ICP备2023011465号-2
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
